<div ngDefaultControl>
  <form [formGroup]="form">
    <div class="input input--custom" *ngIf="inputType === 'custom'">
      <div class="input_increase-decrease">
        <div class="fal fa-minus" *ngIf="!increase"></div>
        <div class="fal fa-plus" *ngIf="increase"></div>
      </div>
      <input
        class="input_input input_input--custom"
        type="number"
        formControlName="custom"
        min="0"
        (keypress)="restrictNumeric($event)"
      />
      <app-input-switcher
        [options]="[
          { display: 'dollar', value: 'D' },
          { display: 'percent', value: 'P' }
        ]"
        formControlName="isPercent"
      ></app-input-switcher>
      <div class="input_select-icon" (click)="toggleInputType()">
        <i class="fal fa-times"></i>
      </div>
    </div>
    <div class="input input--select" *ngIf="inputType !== 'custom'">
      <select
        class="input_input input_input--select"
        [ngClass]="{ 'ng-touched ng-invalid': control.errors }"
        formControlName="select"
      >
        <option value="{{ option.value }}" *ngFor="let option of selectOptions">
          {{ option.name }}
        </option>
      </select>
    </div>
    <p *ngIf="control.errors" class="error" [ngClass]="{'error--custom' : inputType !== 'custom'}">
      Beat aggressively must be selected for both offer types
    </p>
  </form>
</div>
